import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 796 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M56.889 910.222c0 62.578 51.2 113.778 113.778 113.778h455.111c62.578 0 113.778-51.2 113.778-113.778v-568.889c0-62.578-51.2-113.778-113.778-113.778h-455.111c-62.578 0-113.778 51.2-113.778 113.778v568.889zM739.556 56.889h-142.222l-40.391-40.391c-10.24-10.24-25.031-16.498-39.822-16.498h-237.796c-14.791 0-29.582 6.258-39.822 16.498l-40.391 40.391h-142.222c-31.289 0-56.889 25.6-56.889 56.889s25.6 56.889 56.889 56.889h682.667c31.289 0 56.889-25.6 56.889-56.889s-25.6-56.889-56.889-56.889z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgDelete);
export default ForwardRef;
